import React from 'react';
import { Badge } from '../ui/badge';

/**
 * Lista de ranking (posição + avatar + nickname + moedas).
 * Usado para variantes Weekly/General × AGENTE/HOST no dashboard do afiliado.
 *
 * Props:
 * - items: array de objetos com { id, reseller_id, kako_avatar, nickname, position, week_coins?, total_sales_coins?, type }
 * - coinsField: 'week_coins' | 'total_sales_coins'
 * - coinsLabel: legenda embaixo do valor (ex: 'Esta semana', 'Total geral')
 * - currentResellerId: id do afiliado logado (para destacar "Você")
 * - emptyMessage: texto quando lista vazia
 * - matchResellerBy: 'reseller_id' | 'id' — campo usado para casar com o current
 */
const RankingList = ({
  items = [],
  coinsField,
  coinsLabel,
  currentResellerId,
  emptyMessage = 'Nenhum registro',
  matchResellerBy = 'reseller_id',
}) => {
  if (!items || items.length === 0) {
    return <p className="text-center text-gray-500 py-8">{emptyMessage}</p>;
  }

  return (
    <div className="space-y-3">
      {items.map((r) => {
        const isMe = r[matchResellerBy] === currentResellerId;
        return (
          <div
            key={r.id || r.reseller_id}
            className={`p-3 rounded-lg border-2 transition-all ${
              isMe ? 'bg-purple-50 border-purple-400 shadow-lg' : 'bg-white border-gray-200'
            } ${
              r.position === 1
                ? 'border-yellow-400'
                : r.position === 2
                ? 'border-gray-400'
                : r.position === 3
                ? 'border-orange-400'
                : ''
            }`}
          >
            <div className="flex items-center gap-3">
              <div className="text-2xl font-bold min-w-[40px] text-center">
                {r.position === 1 && '🥇'}
                {r.position === 2 && '🥈'}
                {r.position === 3 && '🥉'}
                {r.position > 3 && `${r.position}º`}
              </div>
              {r.kako_avatar && (
                <img
                  src={r.kako_avatar}
                  alt={r.nickname}
                  className="w-10 h-10 rounded-full border-2 border-white shadow"
                />
              )}
              <div className="flex-1">
                <p className="font-bold">{r.nickname}</p>
                {isMe && <Badge variant="default" className="text-xs">Você</Badge>}
              </div>
              <div className="text-right">
                <p className="text-xl font-bold text-purple-600">
                  {(r[coinsField] || 0).toLocaleString()} 🪙
                </p>
                <p className="text-xs text-gray-500">{coinsLabel}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RankingList;
